module.exports = __webpack_public_path__ + "assets/img/singularC.3ca8d38f.png";